<template>
  <div class="cmp_pic_enlarge_mask" v-if="showFlag" @click="close()">
    <img :src="picUrl" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      picUrl: "",
      showFlag: false,
    };
  },
  methods: {
    show(url) {
      if (!url) return false;
      this.picUrl = url;
      this.showFlag = true;
    },
    close() {
      this.picUrl = "";
      this.showFlag = false;
    },
  },
};
</script>

<style lang="less" scoped>
.cmp_pic_enlarge_mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 60%;
    animation-name: bounceIn;
    animation-duration: 0.5s;
  }
}

@keyframes bounceIn {
  0% {
    transform: scale3d(0, 0, 0);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
</style>
